module.exports = __webpack_public_path__ + "static/img/title_image.d6fc65c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard/title_image.png
// module id = 4OPI
// module chunks = 0